import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import OverviewCmp, { OverviewProps } from "./Overview"

export interface OverviewWrapperBlokProps {
  blok: OverviewProps & blokType
}

const Overview: React.FC<OverviewWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <OverviewCmp
      degree={blok.degree}
      program={blok.program}
      type={blok.type}
      module={blok.module}
      init_items_value={parseInt(blok.init_items_value)}
      load_more_value={parseInt(blok.load_more_value)}
      hide_filters={blok.hide_filters}
      hide_programs={blok.hide_programs}
      hide_degree_filter={blok.hide_degree_filter}
      hide_program_filter={blok.hide_program_filter}
      hide_type_filter={blok.hide_type_filter}
    />
  </SbEditable>
)

export default Overview 
